(()=>{
  const ROOT='[data-hfd]';
  const CDN='https://cdn.shopify.com/s/files/1/1060/5084/7062/files/';

  function addStyles(){
    if(document.getElementById('hfd-searchable-dropdown-style'))return;
    const style=document.createElement('style');
    style.id='hfd-searchable-dropdown-style';
    style.textContent=`
      [data-hfd] .hfd__select-row{overflow:visible!important;position:relative}
      [data-hfd] .hfd__select-row.is-dropdown-open{z-index:60}
      [data-hfd] .hfd__native-search-select,[data-hfd] .hfd__native-type-select{display:none!important}
      [data-hfd] .hfd__search-select,[data-hfd] .hfd__type-select{position:relative;min-width:0;width:100%;height:44px;background:#fff}
      [data-hfd] .hfd__search-select{border-left:1px solid #e4eaf0}
      [data-hfd] .hfd__search-select.is-disabled,[data-hfd] .hfd__type-select.is-disabled{pointer-events:none;background:#f3f5f7}
      [data-hfd] .hfd__search-trigger{width:100%;height:44px;border:0;background:#fff;color:#14213d;padding:0 30px 0 10px;text-align:left;font:inherit;cursor:pointer;position:relative;overflow:hidden;display:flex;align-items:center;gap:8px}
      [data-hfd] .hfd__search-select.is-disabled .hfd__search-trigger,[data-hfd] .hfd__type-select.is-disabled .hfd__search-trigger{background:#f3f5f7;color:#9ba7b6;cursor:default}
      [data-hfd] .hfd__search-trigger:after{content:'⌄';position:absolute;right:10px;top:50%;transform:translateY(-54%);font-size:16px;color:#66768a}
      [data-hfd] .hfd__search-select.is-open .hfd__search-trigger:after,[data-hfd] .hfd__type-select.is-open .hfd__search-trigger:after{content:'⌃'}
      [data-hfd] .hfd__search-menu{position:absolute;left:-1px;right:-1px;top:calc(100% + 4px);z-index:100;background:#fff;border:1px solid #cbd7e4;border-radius:7px;box-shadow:0 10px 26px rgba(10,27,67,.16);padding:8px;display:none;max-height:310px}
      [data-hfd] .hfd__search-select.is-open .hfd__search-menu,[data-hfd] .hfd__type-select.is-open .hfd__search-menu{display:block}
      [data-hfd] .hfd__type-select .hfd__search-menu{min-width:196px;max-height:none}
      [data-hfd] .hfd__search-box{position:relative;margin-bottom:7px}
      [data-hfd] .hfd__search-box:before{content:'⌕';position:absolute;left:10px;top:50%;transform:translateY(-51%);font-size:17px;color:#7d8ca0;pointer-events:none}
      [data-hfd] .hfd__search-input{width:100%;height:38px;border:1px solid #ccd8e5;border-radius:6px;background:#fff;padding:0 10px 0 31px;font:inherit;color:#14213d;outline:none}
      [data-hfd] .hfd__search-input:focus{border-color:#087df5;box-shadow:0 0 0 2px rgba(8,125,245,.12)}
      [data-hfd] .hfd__search-options{max-height:245px;overflow:auto;overscroll-behavior:contain}
      [data-hfd] .hfd__search-option{display:flex;align-items:center;gap:8px;width:100%;border:0;background:#fff;color:#14213d;border-radius:5px;padding:7px 10px;text-align:left;font:inherit;cursor:pointer}
      [data-hfd] .hfd__search-option:hover,[data-hfd] .hfd__search-option:focus{background:#eef6ff;outline:none}
      [data-hfd] .hfd__search-option.is-selected{background:#e7f2ff;color:#0873d6;font-weight:700}
      [data-hfd] .hfd__search-empty{padding:10px;color:#7a8797;text-align:center;font-size:1.35rem}
      [data-hfd] .hfd__search-flag{width:24px;height:16px;object-fit:cover;flex:0 0 auto;border-radius:2px;border:1px solid #e4eaf0;background:#f4f7fb}
      [data-hfd] .hfd__search-flag.is-sports{object-fit:contain;background:#fff}
      [data-hfd] .hfd__search-label{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
    `;
    document.head.appendChild(style);
  }

  function isCountryCode(value){
    return /^[a-z]{2}$/i.test(String(value||''));
  }

  function optionImageUrl(option){
    const value=String(option?.value||'');
    const library=window.__hfdUploadLibrary?.get?.(value);
    if(library?.dataUrl)return library.dataUrl;
    if(/^up_/i.test(value))return '';
    if(isCountryCode(value)) return `https://flagcdn.com/w80/${value.toLowerCase()}.png`;
    const file=option?.dataset?.file||value;
    if(!file) return '';
    return `${CDN}${file}.png`;
  }

  function appendOptionLabel(host,option,eager=false,skipImage=false){
    host.replaceChildren();
    const label=document.createElement('span');
    label.className='hfd__search-label';
    label.textContent=option?option.textContent:'Select';
    const url=skipImage?'':optionImageUrl(option);
    if(url){
      const img=document.createElement('img');
      img.className='hfd__search-flag'+(isCountryCode(option.value)?'':' is-sports');
      img.alt='';
      img.loading=eager?'eager':'lazy';
      img.decoding='async';
      img.src=url;
      img.onerror=()=>img.remove();
      host.append(img,label);
      return;
    }
    host.append(label);
  }

  function closeAll(except){
    document.querySelectorAll(`${ROOT} .hfd__search-select.is-open, ${ROOT} .hfd__type-select.is-open`).forEach(box=>{
      if(box===except)return;
      box.classList.remove('is-open');
      box.closest('[data-select-row]')?.classList.remove('is-dropdown-open');
    });
  }

  function enhance(select,kind='flag'){
    const isType=kind==='type';
    const flag=isType?'typeEnhanced':'searchEnhanced';
    if(select.dataset[flag])return;
    select.dataset[flag]='1';
    select.classList.add(isType?'hfd__native-type-select':'hfd__native-search-select');

    const box=document.createElement('div');
    box.className=isType?'hfd__type-select':'hfd__search-select';
    const trigger=document.createElement('button');
    trigger.type='button';
    trigger.className='hfd__search-trigger';
    trigger.setAttribute('aria-haspopup','listbox');
    trigger.setAttribute('aria-expanded','false');

    const menu=document.createElement('div');
    menu.className='hfd__search-menu';
    const options=document.createElement('div');
    options.className='hfd__search-options';
    options.setAttribute('role','listbox');
    let input=null;
    if(!isType){
      const searchBox=document.createElement('div');
      searchBox.className='hfd__search-box';
      input=document.createElement('input');
      input.type='search';
      input.className='hfd__search-input';
      input.placeholder='Search…';
      input.autocomplete='off';
      input.setAttribute('aria-label','Search options');
      searchBox.appendChild(input);
      menu.append(searchBox,options);
    }else{
      menu.append(options);
    }
    box.append(trigger,menu);
    select.parentNode.insertBefore(box,select);

    function syncLabel(){
      const selected=select.options[select.selectedIndex];
      appendOptionLabel(trigger,selected,true,isType);
      box.classList.toggle('is-disabled',select.disabled);
      trigger.disabled=select.disabled;
      if(select.disabled)close();
    }

    function render(filter=''){
      const q=filter.trim().toLowerCase();
      const matches=[...select.options].filter(o=>!q||o.textContent.toLowerCase().includes(q));
      options.replaceChildren();
      if(!matches.length){
        const empty=document.createElement('div');
        empty.className='hfd__search-empty';empty.textContent='No matches';options.appendChild(empty);return;
      }
      matches.forEach(option=>{
        const item=document.createElement('button');
        item.type='button';
        item.className='hfd__search-option'+(option.value===select.value?' is-selected':'');
        appendOptionLabel(item,option,false,isType);
        item.dataset.value=option.value;
        item.setAttribute('role','option');
        item.setAttribute('aria-selected',option.value===select.value?'true':'false');
        item.addEventListener('click',()=>{
          if(select.value!==option.value){
            select.value=option.value;
            select.dispatchEvent(new Event('change',{bubbles:true}));
          }
          syncLabel();
          close();
        });
        options.appendChild(item);
      });
    }

    function open(){
      if(select.disabled)return;
      closeAll(box);
      box.classList.add('is-open');
      box.closest('[data-select-row]')?.classList.add('is-dropdown-open');
      trigger.setAttribute('aria-expanded','true');
      if(input)input.value='';
      render();
      if(input)requestAnimationFrame(()=>input.focus());
    }

    function close(){
      box.classList.remove('is-open');
      box.closest('[data-select-row]')?.classList.remove('is-dropdown-open');
      trigger.setAttribute('aria-expanded','false');
    }

    trigger.addEventListener('click',()=>box.classList.contains('is-open')?close():open());
    if(input){
      input.addEventListener('input',()=>render(input.value));
      input.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();close();trigger.focus();}});
    }
    select.addEventListener('change',()=>{syncLabel();if(box.classList.contains('is-open'))render(input?input.value:'');});

    const observer=new MutationObserver(()=>{syncLabel();if(box.classList.contains('is-open'))render(input?input.value:'');});
    observer.observe(select,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    syncLabel();
  }

  function init(){
    addStyles();
    const root=document.querySelector(ROOT);if(!root)return;
    root.querySelectorAll('[data-flag-selection]').forEach(select=>enhance(select,'flag'));
    root.querySelectorAll('[data-selection-type]').forEach(select=>enhance(select,'type'));

    const observer=new MutationObserver(()=>{
      root.querySelectorAll('[data-flag-selection]').forEach(select=>enhance(select,'flag'));
      root.querySelectorAll('[data-selection-type]').forEach(select=>enhance(select,'type'));
    });
    observer.observe(root,{childList:true,subtree:true});

    document.addEventListener('click',e=>{
      if(!e.target.closest('.hfd__search-select,.hfd__type-select'))closeAll();
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
